// extracted by mini-css-extract-plugin
module.exports = {"Table":"Table_Table__2DxTv","responsiveTable":"Table_responsiveTable__2mI8e"};